import ApplicationController from '../support/application_controller'

export default class extends ApplicationController {

  static targets = []

  initialize() {
    this.element.value = JSON.stringify(JSON.parse(this.element.value), null, 4)
  }

  // ==== Controllers

  // ==== Actions

  // ==== Getters

  // ==== Setters

  // ==== Private

  // ==== Channels

}
